import { Injectable } from "@angular/core";
import {
  CatalogCategoryClient,
  CatalogCategoryViewModel,
} from "src/domain/client";

@Injectable({
  providedIn: "root",
})
export class CatalogCategoryService {
  constructor() {}

  getCatalogCategory(
    categoryId: number,
    channelRequestId: string | undefined,
  ): Promise<CatalogCategoryViewModel> {
    return new CatalogCategoryClient().details(categoryId, channelRequestId);
  }

  getCatalogCategoriesByIds(
    ids: number[],
    channelRequestId: string | undefined,
  ): Promise<CatalogCategoryViewModel[]> {
    return new CatalogCategoryClient().getCategoriesByIds(
      ids,
      channelRequestId,
    );
  }
}
